module.exports = __webpack_public_path__ + "static/media/viking_axe.a3fbfffa.png";